import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "../styles/navbar.css";
import Image from "react-bootstrap/Image";
import logo from "../assets/logo.png";

export default function MainNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    function onScroll() {
      if (window.scrollY > 30) setScrolled(true);
      else setScrolled(false);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Container
      className={`custom-navbar p-0 ${scrolled ? "navbar-scrolled" : ""} ${expanded ? "navbar-expanded" : ""}`}
    >
      <Navbar 
        expand="md" 
        className="py-0 nav-links mx-2"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Navbar.Brand href="/" className="navbar-brand-custom p-0">
          <Image
            src={logo}
            alt="Financials.hu"
            height="50"
            width="54"
            className="logo-hover-bg"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" className="custom-toggler border-0 shadow-none">
          <FontAwesomeIcon 
            icon={expanded ? faTimes : faBars} 
            className="toggler-icon" 
          />
        </Navbar.Toggle>

        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto py-3 py-md-0">
            <Nav.Link href="/dualis-kepzes" onClick={() => setExpanded(false)}>
              <span>Duális képzés</span>
            </Nav.Link>

            <NavDropdown
              title={
                <span className="dropdown-title">
                  Pályázatok
                  <FontAwesomeIcon
                    icon={faArrowDown}
                    className="dropdown-arrow"
                  />
                </span>
              }
              id="services-dropdown"
              className="dropdown-custom"
              show={open}
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
              onClick={() => setOpen(!open)}
            >
              <NavDropdown.Item
                className="dropdown-pill"
                href="/nemzeti-bajnokok"
                onClick={() => setExpanded(false)}
              >
                Nemzeti Bajnokok
              </NavDropdown.Item>
              <NavDropdown.Item
                className="dropdown-pill"
                href="/elmaradott-tersegek-tamogatasa"
                onClick={() => setExpanded(false)}
              >
                Hátrányos helyzetű régiók
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link href="/vallalati-hitel" onClick={() => setExpanded(false)}>
              <span>Hitel</span>
            </Nav.Link>
            <Nav.Link href="/szamlaoptimalizalas" onClick={() => setExpanded(false)}>
              <span>Számlaoptimalizálás</span>
            </Nav.Link>
            <Nav.Link href="/penzugyi-orangyal" onClick={() => setExpanded(false)}>
              <span>Partnerség</span>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}
